import React from "react";
import { useSourceSystem } from "../hooks/useSourceSystem";

export default function ReviewAssumptions() {
  const {
    sourceSystem: {
      initialOfferContent: { assumptionsContent }
    }
  } = useSourceSystem();

  return (
    <div className="ch-text--center ch-mb--0 ch-color--ac-black subject-valuation">
      {assumptionsContent && <>{assumptionsContent}</>}
    </div>
  );
}
